import { FC } from 'react';

import { AppFormattedMessage } from '../../components/app-formatted-message/index';
import Button from '../../components/button/index';
import { Tooltip } from '../../components/tooltip/index';
import { SharePlanUnionType } from '../../types/pool-plans.types';
import { VestingTask } from '../../types/vesting-tasks.types';

export type DeletePoolModalProps = {
  isSharePlan?: boolean;
  items: SharePlanUnionType[] | VestingTask[];
  onClose: () => void;
};

export const DeleteBlockModal: FC<DeletePoolModalProps> = ({ onClose, items, isSharePlan }) => (
  <div className="flex min-w-[300px] max-w-[453px] shrink-0 flex-col gap-8 rounded bg-white p-4">
    <div className="flex flex-col gap-1">
      <span className="text-xl font-[550] text-gray-700">
        <AppFormattedMessage id="UNABLE_DELETE" />
      </span>
      <span className="text-xs font-[450] text-gray-500">
        {isSharePlan ? (
          'The plan cannot be deleted as they are associated to stakeholders. Please review associations before deleting them.'
        ) : (
          <AppFormattedMessage id="DELETE_POOL_WARNING" />
        )}
      </span>
    </div>
    <div className="flex flex-col gap-3">
      {items.map((item, i) => (
        <Tooltip
          childrenWrapperClassName="max-w-[450px]"
          content={'name' in item ? item?.name : item?.grantItem?.stakeholder?.fullName}
        >
          <span className="truncate text-xs font-[450] text-gray-700">
            {i + 1}. {'name' in item ? item?.name : item?.grantItem?.stakeholder?.fullName}
          </span>
        </Tooltip>
      ))}
    </div>
    <div className="flex h-11 justify-end gap-4" data-permission-required>
      <Button
        className="h-full w-fit bg-brand-700 px-6 py-[10px] text-sm font-[550] text-white"
        onClick={onClose}
        styleType="NONE"
      >
        <AppFormattedMessage id="OKAY" />
      </Button>
    </div>
  </div>
);
